import React from "react";
import { connect } from "react-redux";
import {FormattedMessage} from "react-intl";

import Button from "@mui/material/Button";

import {getLookList} from "../../../lookNavigation/lookFunctions";
import {setGroheWizardStep} from "../../../../../actions/groheQuotingToolFunctions";

const GroheQuotingToolIntro = (props) => {

  const {setGroheWizardStep} = props;
  const featureGroups = getLookList();
  if (!featureGroups) {
    return null
  }

  const buttonStartWizardClick = () => {
    setGroheWizardStep(0);
  }

  const buttonStartProWizardClick = () => {

  }

  return (
    <div className="grohe-section__intro">
      <h2 className="grohe-section__title">
        <FormattedMessage id="grohe.wizard.vanity.title"/>
      </h2>
      <p className="grohe-section__description">
        <FormattedMessage id="grohe.wizard.vanity.description"/>
      </p>
      <div className="lk-feature__buttons">
        <div className="lk-button grohe-lk__button">
          <Button className={"look-button look-button--secondary grohe-look__button "}
                  onClick={() => buttonStartWizardClick()}>
            <FormattedMessage id={"grohe.wizard.vanity.button.start"}/>
          </Button>
        </div>
        <div className="lk-button grohe-lk__button">
          <Button className={"look-button grohe-look__button grohe-look__button--quaternary"}
                  onClick={buttonStartProWizardClick}>
            <FormattedMessage id={"grohe.wizard.vanity.button.startPro"}/>
          </Button>
        </div>
      </div>
    </div>
  )
};

const mapStateToProps = (store) => {
  const {lookPageOpened} = store.lookState;
  return {
    lookPageOpened,
  };
};

const mapDispatchToProps = {
  setGroheWizardStep
};

export default connect(mapStateToProps, mapDispatchToProps)(GroheQuotingToolIntro)
